var _path, _path2, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnarchiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.45455 10.4545H12.9091",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.12655 18.7017C2.41076 19.4601 3.14233 20 4 20H16C17.1046 20 18 19.1046 18 18V8H12.8282L2.12655 18.7017ZM10.9998 7H1C0.447715 7 0 6.55228 0 6V3C0 2.44772 0.447715 2 1 2H15.9998L10.9998 7ZM13.8282 7H19C19.5523 7 20 6.55228 20 6V3C20 2.44772 19.5523 2 19 2H18.8282L13.8282 7ZM9.99982 8L2 15.9998V8H9.99982Z",
    fill: "#ED9A08"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 0.707107,
    x2: 0.707107,
    y2: 18,
    stroke: "#ED9A08",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnarchiveIcon);
export default __webpack_public_path__ + "static/media/unarchive-icon.1b4983db0dbf30a6506d9e0c91996708.svg";
export { ForwardRef as ReactComponent };